import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface QueryParams {
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序，true-正序，false-反序 */
  asc?: boolean
  /** 搜索关键词 */
  key_word?: string
  /** 排序字段 */
  sort?: string
  /** 策略id */
  strategy_id?: string
}

export interface UnApproveItem {
  /** 记录id */
  record_id: number
  /** 审核时间 */
  apply_time: number
  /** 存储设备名 */
  peripheral_name: string
  /** 存储设备类型 */
  peripheral_type: string
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 申请人 */
  user_mark: string
  /** 分组id */
  group_id: number
  /** 分组名 */
  group_name: string
  /** 内网IP */
  system_ip: string
  /** 外网IP */
  client_ip: string
  /** 存储设备id */
  peripheral_id?: string
  /** 申请状态,1-未审批，2-通过，3-拒绝 4-已失效 */
  apply_state?: number
  /** 触发策略 */
  strategy_name?: string
}

export interface DeviceStatus {
  /** 记录id */
  record_id: number
  /** 是否同意 */
  is_agree: boolean
  /** 理由 */
  reason: string
}

@Injectable()
export default class UnApproveViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getUnApproveList (data: QueryParams) {
    return this.http.post<{
      /** 终端视图信息列表 */
      list: UnApproveItem[]
      /** 总数 */
      total: number
    }>('/peripheralcontrol/unapproved-list/get', data)
  }

  handleDeviceApprove (data: DeviceStatus) {
    return this.http.post<void>('/peripheralcontrol/storage-device/approve', data)
  }
}
